import {useQuery} from 'admin/lib/apollo'
import {GET_SERVICES} from 'admin/gql/Services.gql'
import {NumberParam, StringParam, useQueryParams, withDefault} from 'use-query-params'

export default (organisationId, accountId = undefined, status = undefined, {includeFilters = true} = {}) => {
  const [filters, setFilters] = useQueryParams({
    q: withDefault(StringParam, ''),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sortBy: withDefault(StringParam, 'name'),
    sortDirection: withDefault(StringParam, 'asc'),
    sortLabel: withDefault(StringParam, 'Name')
  })

  const variables = {organisationId, status, accountId, ...(includeFilters ? filters : {})}
  const {data} = useQuery(GET_SERVICES, {variables})
  const response = data ? data.services : []

  return {
    filters,
    setFilters,
    services: response.collection || [],
    totalCount: response.metadata ? response.metadata.totalCount : 0
  }
}
